import React from 'react';
import imgBackgroundRemover from '../../media/modal-feature-pro/background-remover.png';
import imgBackgroundRemoverMobile from '../../media/modal-feature-pro/background-remover-mobile@3x.png';
import imgBrandKit from '../../media/modal-feature-pro/brand-kit.png';
import imgBrandKitMobile from '../../media/modal-feature-pro/brand-kit-mobile@3x.png';
import imgNoCredits from '../../media/modal-feature-pro/no-credits.png';
import imgNoCreditsMobile from '../../media/modal-feature-pro/no-credits-mobile@3x.png';
import imgScaleDesign from '../../media/modal-feature-pro/scale-design.png';
import imgScaleDesignMobile from '../../media/modal-feature-pro/scale-design-mobile@3x.png';
import imgStudioPro from '../../media/modal-feature-pro/studio-pro.png';
import imgStudioProMobile from '../../media/modal-feature-pro/studio-pro-mobile@3x.png';
import imgStudioProOffer from '../../media/modal-feature-pro/studio-pro-offer.png';
import imgStudioProOfferMobile from '../../media/modal-feature-pro/studio-pro-offer-mobile@3x.png';
import { useResize } from '@/hooks/useResize';
import { ID_PRO_FEATURES } from '../../studio.enum';

const HGImageFeaturePro = ({ modalId }) => {
  const alt = 'Studio Pro';
  const windowRect = useResize();
  const { width } = windowRect;
  const mobile = width < 960;

  const imageRules = {
    [ID_PRO_FEATURES.BACKGROUND_REMOVER]: <img src={mobile ? imgBackgroundRemoverMobile : imgBackgroundRemover} alt={alt} />,
    [ID_PRO_FEATURES.BRAND_KIT]: <img src={mobile ? imgBrandKitMobile : imgBrandKit} alt={alt} />,
    [ID_PRO_FEATURES.NO_CREDITS]: <img src={mobile ? imgNoCreditsMobile : imgNoCredits} alt={alt} />,
    [ID_PRO_FEATURES.SCALE_DESIGN]: <img src={mobile ? imgScaleDesignMobile : imgScaleDesign} alt={alt} />,
    [ID_PRO_FEATURES.STUDIO_PRO]: <img src={mobile ? imgStudioProMobile : imgStudioPro} alt={alt} />,
    [ID_PRO_FEATURES.STUDIO_PRO_OFFER]: <img src={mobile ? imgStudioProOfferMobile : imgStudioProOffer} alt={alt} />,
  };

  return imageRules[modalId];
};

export default HGImageFeaturePro;
